import { render, staticRenderFns } from "./CustomerTypeDialog.vue?vue&type=template&id=540ac000"
import script from "./CustomerTypeDialog.vue?vue&type=script&lang=js"
export * from "./CustomerTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports